module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_8017.9658aefc.png";